import React from 'react';
import {
  DirectionsRun as DirectionsRunIcon,
  SportsCricket as SportsCricketIcon,
  SportsHandball as SportsHandballIcon,
  SportsHockey as SportsHockeyIcon,
  SportsSoccer as SportsSoccerIcon,
  SportsTennis as SportsTennisIcon,
} from '@mui/icons-material';

export interface SportDiscoveryCard {
  sport: string;
  accent: string;
  gradient: string;
  icon: React.ReactNode;
  skills: string;
  drills: string;
  fitness: string;
  skillLabel?: string;
  highlight?: boolean;
}

export const SPORT_DISCOVERY_CARDS: SportDiscoveryCard[] = [
  {
    sport: 'Badminton',
    accent: '#0f4c81',
    gradient: 'linear-gradient(135deg, #eef6ff 0%, #e9f7f3 100%)',
    icon: <SportsHandballIcon />,
    skills: '200+',
    drills: '60+',
    fitness: '40+',
    skillLabel: 'Strokes & shots',
    highlight: true,
  },
  {
    sport: 'Football',
    accent: '#1b6b5b',
    gradient: 'linear-gradient(135deg, #edf8f3 0%, #eaf6ff 100%)',
    icon: <SportsSoccerIcon />,
    skills: '80+',
    drills: '35+',
    fitness: '25+',
    skillLabel: 'Shooting',
  },
  {
    sport: 'Ice Hockey',
    accent: '#2251a3',
    gradient: 'linear-gradient(135deg, #eef4ff 0%, #f4fbff 100%)',
    icon: <SportsHockeyIcon />,
    skills: '110+',
    drills: '40+',
    fitness: '30+',
    skillLabel: 'Puck skills',
  },
  {
    sport: 'Cricket',
    accent: '#1f5f8b',
    gradient: 'linear-gradient(135deg, #edf7ff 0%, #f1faff 100%)',
    icon: <SportsCricketIcon />,
    skills: '—',
    drills: '—',
    fitness: '—',
    skillLabel: 'Skills',
  },
  {
    sport: 'Tennis',
    accent: '#245c9f',
    gradient: 'linear-gradient(135deg, #f2f7ff 0%, #eef9ff 100%)',
    icon: <SportsTennisIcon />,
    skills: '—',
    drills: '—',
    fitness: '—',
    skillLabel: 'Strokes',
  },
  {
    sport: 'Athletics',
    accent: '#2b5f9e',
    gradient: 'linear-gradient(135deg, #eff4ff 0%, #edf8ff 100%)',
    icon: <DirectionsRunIcon />,
    skills: '—',
    drills: '—',
    fitness: '—',
    skillLabel: 'Events',
  },
];
